let startupLanguageReady = Promise.resolve();

export function beginStartupLanguageActivation() {
  let finish;
  startupLanguageReady = new Promise((resolve) => {
    finish = resolve;
  });
  return finish;
}

export function waitForStartupLanguage() {
  return startupLanguageReady;
}
